import React, { useEffect, useRef } from "react";
import servicesData from "../data/serviceAreaData";

export default function AreaCarousel() {
const carouselRef = useRef(null);

useEffect(() => {
const el = carouselRef.current;
let scrollAmount = 0;

const interval = setInterval(() => {
if (!el) return;
scrollAmount += 2;
if (scrollAmount >= el.scrollWidth - el.clientWidth) scrollAmount = 0;
el.scrollBy({ left: 2, behavior: 'smooth' });
}, 50);

return () => clearInterval(interval);
}, []);


const scrollLeft = () => {
carouselRef.current.scrollBy({ left: -200, behavior: "smooth" });
};


const scrollRight = () => {
carouselRef.current.scrollBy({ left: 200, behavior: "smooth" });
};
return (
<section className="area-section">
<h2>Our Service Areas</h2>
<div className="carousel-wrapper">
<button className="carousel-btn left" onClick={scrollLeft}>‹</button>


<div className="area-carousel" ref={carouselRef}>
{servicesData.map((a, i) => (
<span key={i} className="area-chip">{a}</span>
))}
</div>


<button className="carousel-btn right" onClick={scrollRight}>›</button>
</div>
</section>
);
}